import React from 'react';

import Button from '@material-ui/core/Button';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Box from '@material-ui/core/Box';

import { makeStyles } from '@material-ui/core/styles';

import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import EqualizerIcon from '@material-ui/icons/Equalizer';

import Me from './Me';
import Analytics from './Analytics';
import Game from './Game';
import Web from './Web';
import Geo from './Geo';

const useStyles = makeStyles((theme) => ({
  nav: {
    marginTop: 40,
    display: 'flex',
    justifyContent: 'center',
  },
  link: {
    fontSize: 30,
    display: 'flex',
  },
  icon: {
    marginRight: theme.spacing(0.5),
    width: 30,
    height: 30,
  },
}));

function getComponent(cid) {
  switch(cid) {
    case 0:
      return <Me />;
    case 1:
      return <Web />;
    case 2:
      return <Game />;
    case 3:
      return <Analytics />;
    case 4:
      return <Geo />;
    default:
      return <Me />;
  }
}

export default function Dashboard() {
  const [tab, setTab] = React.useState(0);
  const classes = useStyles();

  return (
    <Box color="text.primary">
      <Breadcrumbs aria-label="breadcrumb" className={classes.nav}>
        <Button className={classes.link} onClick={() => setTab(0)}>
          <AccountCircleIcon className={classes.icon} />
          Home
        </Button>
        <Button className={classes.link} onClick={() => setTab(1)}>
          <EqualizerIcon className={classes.icon} />
          Web Development
        </Button>
        <Button className={classes.link} onClick={() => setTab(2)}>
          <EqualizerIcon className={classes.icon} />
          iOS Game
        </Button>
        <Button className={classes.link} onClick={() => setTab(3)}>
          <EqualizerIcon className={classes.icon} />
          Analytics
        </Button>
        <Button className={classes.link} onClick={() => setTab(4)}>
          <EqualizerIcon className={classes.icon} />
          Geophysics
        </Button>
      </Breadcrumbs>
      {
        getComponent(tab)
      }
    </Box>
  );
}